import React from 'react';
import PropTypes from 'prop-types';
import { CardWrap, CardBody, Cover, Header, Footer } from './Card.stc';

function Card(props) {
    const {
        size,
        cover,
        footer,
        header,
        children,
        coverHeight,
        ...restOfProps
    } = props;

    return (
        <CardWrap {...restOfProps}>
            {header && <Header cardSize={size}>{header}</Header>}
            {cover && <Cover coverHeight={coverHeight} src={cover} />}

            <CardBody cardSize={size}>{children}</CardBody>

            {footer && <Footer cardSize={size}>{footer}</Footer>}
        </CardWrap>
    );
}

Card.propTypes = {
    size: PropTypes.string,
    cover: PropTypes.string,
    coverHeight: PropTypes.string,
    header: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.func,
    ]),
    footer: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.func,
    ]),
};

export default Card;
